/**
 * This file was auto-generated by Fern from our API Definition.
 */

/**
 * The data to create a file.
 */
export interface FileData {
    /** Primitive string type. */
    filename?: string;
    /** Just regular URI according to [RFC 3986](https://www.rfc-editor.org/rfc/rfc3986). */
    id?: string;
}
